import React, { useEffect, useState } from "react";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  Tab,
  Tabs,
  TextField,
  Typography
} from "@mui/material";
// import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useLocation, useNavigate } from "react-router";
import Sidebar from "./components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { ThreeDots } from "react-loader-spinner";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import OfflineBoltIcon from "@mui/icons-material/OfflineBolt";
import moment from "moment/moment";
import MainLoader from "./components/MainLoader";
import imgurl from "./assests/images/imgurl";
import noDataFound from "../src/assests/images/no-report-ic.svg";
import inProcessIcon from "../src/assests/images/no-report-ic.gif";
import AlertComp from "./Alert";
import i18next from "i18next";
import SyncIcon from '@mui/icons-material/Sync';
import ManIcon from '@mui/icons-material/Man';
import WomanIcon from '@mui/icons-material/Woman';
import DateRangeIcon from '@mui/icons-material/DateRange';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import { clearImagesInRedux, downloadPDF, serviceDown, trackEvent } from "./utils/UtilityFunctions";
import { postApi } from "./api/services";
import HairAnalysisIcon from '../src/assests/images/newimages/icons/hair-analysis.svg'
import HairTreatment from '../src/assests/images/newimages/icons/hair-treatment.png'
import HairTreatmentDisabled from '../src/assests/images/newimages/icons/hair-treatment-disabled.png'
import swal from 'sweetalert';
import CloseIcon from "@mui/icons-material/Close";
import PendingIcon from '@mui/icons-material/Pending';
import ErrorIcon from '@mui/icons-material/Error';
import SearchIcon from "@mui/icons-material/Search";
import PropTypes from 'prop-types';


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const PatientReports = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [alertopen, setalertopen] = useState(false);
  const [alertmsg, setAlertMsg] = useState("");
  const [reportList, setReportList] = useState([]);
  const [patientReportList, setPatientReportList] = useState([])
  const [groupedReportList, setGroupedReportList] = useState({})
  const [tempPatientReportList, setTempPatientReportList] = useState([])
  const [noData, setNoData] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isRotating, setIsRotating] = useState(false);
  const [inProcess, setInProcess] = useState(false);
  const [gender, setGender] = useState('')
  const [showQr, setShowQr] = useState(false)
  const [tabValue, setTabValue] = useState(0)

  let { Topview, Backview, Leftview, Rightview, Frontview, Gender } = useSelector(
    (state) => state.user.profile
  );

  const locale = useSelector((state) => state.language.langData)

  useEffect(() => {
    // getReportList();
    localStorage.getItem('user_role').toUpperCase() === 'NURSE' ? getPatientReportListForNurse() : getPatientReportListForDoctor()
    let genderVal
    if(Gender == '' && !location?.state?.user_obj?.gender){
      genderVal = localStorage.getItem('gender')
    } else if (location?.state?.user_obj?.gender) {
      genderVal = location?.state?.user_obj?.gender
    } else {
      genderVal = Gender
    }
    setGender(genderVal)
    if (
      Frontview &&
      Topview &&
      Leftview &&
      Rightview &&
      location?.state?.from == "previewTest" &&
      genderVal.toUpperCase() == "MALE"
    ) {
      sendReport('male');
    } else if( Frontview && Topview && location?.state?.from == "previewTest" && genderVal.toUpperCase() == "FEMALE"){
      sendReport('female')
    }
  }, []);

  const sendReport = async (genderVal) => {
    setInProcess(true)
    try {
      let imgObj = genderVal.toUpperCase() == "MALE" ?
        {
          front_img: Frontview,
          top_img: Topview,
          left_img: Leftview,
          right_img: Rightview,
        } : 
        {
          front_img: Frontview,
          top_img: Topview,
        }
      setalertopen(true);
      setAlertMsg("processing");
      // setIsLoading(true)
      let apiobj = {
        image_data: imgObj,
        userid: location?.state?.user_obj?.user_id,
        channel: window.cordova ? "mobile" : "webapp",
        assisted_model_flag: true
      };
      console.log("predict_all params", apiobj);
      const data = await postApi('predict_all', apiobj)
      console.log("predict_all data", data);
      location.state.from = "";
      if (Object.keys(data).length > 0) {
        if(data.error){
          serviceDown(navigate, '/taketest')
          await trackEvent('test_submitted', 'fail', data.error, localStorage.getItem('phno'))
          setalertopen(false);
          setAlertMsg("error");
          setIsLoading(false)
        } else {
          // setIsLoading(false)
          await trackEvent('test_submitted', 'success', '', localStorage.getItem('phno'))
          clearImagesInRedux(dispatch)
          setNoData(false);
          setalertopen(false);
          setAlertMsg("completed");
          // getReportList('quickreport', 'inprocess');
          localStorage.getItem('user_role').toUpperCase() === 'NURSE' ? getPatientReportListForNurse() : getPatientReportListForDoctor()
        }
      } else {
        setNoData(true);
      }
    } catch (err) {
      console.log("err", err);
      serviceDown(navigate, '/taketest')
      await trackEvent('test_submitted', 'fail', err, localStorage.getItem('phno'))
      setalertopen(false);
      setAlertMsg("error");
      setIsLoading(false)
    }
  };

  const getReportList = async (received, inprocess) => {
    try {
      setIsLoading(true);
      let apiobj = {
        user_id: localStorage.getItem("user_id") && localStorage.getItem("user_id"),
      };
      console.log("get_hair_analysis_status params", apiobj);
      const data = await postApi('get_hair_analysis_status', apiobj)
      if (data?.length > 0) {
        console.log("get_hair_analysis_status res", data);
        if(received){
          await trackEvent('quick_report_received', 'success', '', localStorage.getItem('phno'))
        } else {
          await trackEvent('report_history_viewed', 'success', '', localStorage.getItem('phno'))
        }     
        setReportList(data);
        setNoData(false);
        setIsLoading(false);
        setIsRotating(false);
        setInProcess(false);
      } else {
        setIsLoading(false);
        setIsRotating(false);
        setNoData(true);
      }
    } catch (err) {
      console.log("err", err);
      if(received) {
        await trackEvent('quick_report_received', 'fail', err, localStorage.getItem('phno'))
      } else {
        await trackEvent('report_history_viewed', 'fail', err, localStorage.getItem('phno'))
      }
      setIsLoading(false)
      serviceDown()
    }
  };

  const getPatientReportListForNurse = async (received, inprocess) => {
    setIsLoading(true)
    let params = {
      nurse_id: JSON.parse(localStorage.getItem('doctorobj'))?.nurse_id
    }
    console.log("get_patient_reports_by_nurse params", params);
    try {
      let res = await postApi('get_patient_reports_by_nurse', params)
      if(res){
        setIsLoading(false)
        console.log("get_patient_reports_by_nurse res", res); 
        setPatientReportList(res)
        setTempPatientReportList(res)
        getOrderList(res)
        if(res?.length > 0){
          setNoData(false);
        }
        setIsRotating(false);
        setInProcess(false);
      }
    } catch (err) {
      console.log("err", err);
      setIsLoading(false)
      serviceDown()
    }
  }

  const getPatientReportListForDoctor = async (received, inprocess) => {
    setIsLoading(true)
    let params = {
      clinic_id: JSON.parse(localStorage.getItem('doctorobj'))?.clinic_id
    }
    console.log("get_patient_reports_by_doctor params", params);
    try {
      let res = await postApi('get_patient_reports_by_doctor', params)
      if(res){
        setIsLoading(false)
        console.log("get_patient_reports_by_doctor res", res); 
        // res[0].reports = [
        //   {norwoodstage: 3, report_id: 123}
        // ]
        setPatientReportList(res)
        setTempPatientReportList(res)
        // setNoData(false);
        if(res?.length > 0){
          setNoData(false);
        }
        setIsRotating(false);
        setInProcess(false);
      }
    } catch (err) {
      console.log("err", err);
      // if(received) {
      //   await trackEvent('quick_report_received', 'fail', err, localStorage.getItem('phno'))
      // } else {
      //   await trackEvent('report_history_viewed', 'fail', err, localStorage.getItem('phno'))
      // }
      setIsLoading(false)
      serviceDown()
    }
  }

  const getReportDetails = async (id) => {
    try {
      setIsLoading(true);
      let apiobj = {
        analysis_id: id,
      };
      console.log("get_hair_analysis_report params", apiobj);
      const data = await postApi('get_hair_analysis_report', apiobj)
      if (data) {
        console.log("get_hair_analysis_report res", data);
        setIsLoading(false);
        swal({
          title: `${i18next.t("Report is invalid")}`,
          text: `${i18next.t("Reason")} : ${data?.report?.final_comments}`,
        });
      }
    } catch (err) {
      console.log("err", err);
      setIsLoading(false)
      serviceDown()
    }
  };

  const goToReport = (report, patient) => {
    console.log("goToReport", report);
    if(report.current_stage === "AI_GENERATED"){
      // getAiReportDetails(report.analysis_id)
      navigate("/resultnew", { state: { analysis_id: report.analysis_id, current_stage: report.current_stage, gender: patient.gender, user_obj: patient}});
    } else {
      if (report.status == "Completed") {
        // localStorage.setItem('report_analysis_id', JSON.stringify(report.analysis_id))
        navigate("/resultnew", { state: { analysis_id: report.analysis_id, current_stage: report.current_stage, gender: patient.gender, user_obj: patient}});
      } else if (report.status === "Rejected") {
        getReportDetails(report.analysis_id);
      } else {
        swal({
          title: `Your report is ${report.status.toLowerCase()}`,
        });
      }
    }
  };

  const getOrderList = async (patientList) => {
    setIsLoading(true)
    let emailAddress = JSON.parse(localStorage.getItem('doctorobj'))?.clinic_email
    let params = {
      email: emailAddress
    }
    console.log("fetch_orders params", params);
    try {
      let res = await postApi('fetch_orders', params)
      if(res.error) {
        setIsLoading(false)
      } else {
        console.log("fetch_orders res", res);
        setIsLoading(false)
        let ordersArr = res.orders.map((order) => {
          const prescriptionNumber = order.customer_note.match(/Prescription Number\s+([A-Z0-9]+)/i)?.[1] || "";
          const patientName = order.customer_note.match(/Patient Name:\s*([^\n]+)/i)?.[1].trim() || "";
          const doctorName = order.customer_note.match(/Doctor Name:\s*([^\n]+)/i)?.[1].trim() || "";
          const dosage = order.customer_note.match(/Dosage prescribed:\s*([^\n]+)/i)?.[1].trim() || "";
          return {
            ...order,
            customer_details: {
              prescription_number: prescriptionNumber,
              patient_name: patientName,
              doctor_name: doctorName,
              dosage: dosage
            }
          };
        })
        let newPatientReportList = patientList.map((patient) => {
          const fullName = `${patient.first_name} ${patient.last_name}`.trim().toLowerCase();
          const matchedOrder = ordersArr.find(
            (order) => order.customer_details.patient_name.toLowerCase() === fullName
          );
          return {
            ...patient,
            ...(matchedOrder ? { customer_details: matchedOrder.customer_details, order_status: matchedOrder.status, order_id: matchedOrder.order_id } : {})
          };
        });
        setPatientReportList(newPatientReportList)
        const groupByList = Object.groupBy(newPatientReportList, ({order_status}) => order_status ?? "unordered")
        // if (groupByList.unordered) {
        //   delete groupByList.unordered;
        //   // delete groupByList.pending;
        // }
        setGroupedReportList(groupByList)
        setTempPatientReportList(groupByList)
        console.log("ordersArr", ordersArr, "newPatientReportList", newPatientReportList, "groupByList", groupByList);
      }
    } catch (err) {
      setIsLoading(false)
      console.log("err", err);
      serviceDown()
    }
  }

  // beta user feedback
  const proceedToNxt = () => {
    let encrypted = encryptPhoneNum(localStorage.getItem('phno'))
      let url = `https://aloxa.ai/feedback?phno=${encrypted}&lang=${locale}`;
      console.log('urlllll', url)
      window.open(url, "_blank");
  };

  const encryptPhoneNum = (phone) => {
    return btoa(encodeURIComponent(phone))
  }

  const handleRotate = () => {
    setIsRotating(true);  
    // getReportList();
    localStorage.getItem('user_role').toUpperCase() === 'NURSE' ? getPatientReportListForNurse() : getPatientReportListForDoctor()
  };

  const handleDownload = (e, report) => {
    e.stopPropagation();
    setIsLoading(true)
    let params = {
      report_id: report.report_id,
      language: locale
    }
    postApi("generate-report", params)
      .then((res) => {
        console.log("generate-report res", res);
        if(res?.pdf_data){
          downloadPDF(res?.pdf_data, report.report_id, locale.toUpperCase())
        }
      })
      .catch((err) => {
        console.log("err");  
        setIsLoading(false)
        serviceDown()
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const handleExplore = async (e, report) => {
    try {
      e.stopPropagation()
      if(report?.norwoodstage == 1 || report?.norwoodstage == 6 || report?.norwoodstage == 7){
        return
      } else {
        await trackEvent('explored_treatment', 'success', "", localStorage.getItem('phno'))
        let encrypted = encryptPhoneNum(localStorage.getItem('phno'))
        let url = `https://shop.alopexia.com/products/alopexia-hair-restoration-medicine?phone=${encrypted}`;
        window.open(url, "_self");
      }
    } catch (err) {
      console.log("err", err);
      await trackEvent('explored_treatment', 'fail', err, localStorage.getItem('phno'))
    }
  }

  const handleClicks = (identifier, patient, evt) => {
    if(identifier === 'prescriptions' && (patient?.prescription_status?.toUpperCase() === 'VALID' || patient?.prescription_status?.toUpperCase() === 'EXPIRED')) {
      evt.stopPropagation();
      // getPrescription(patient, patient?.prescription_status)
      navigate('/allprescriptions', {state: {user_obj: patient}})
    } else if (identifier === 'taketestqr') {
      evt.stopPropagation();
      setShowQr(!showQr)
    } else if (identifier === "treatment") {
      evt.stopPropagation();
      swal({
        title: i18next.t("Put patient on treatment"),
        buttons: {
          cancel: {
            text: i18next.t("No"),
            value: false,
            visible: true,
          },
          confirm: {
            text: i18next.t("Yes"),
            value: true,
            visible: true,
          },
        }
      }).then((val) => {
        if(val){
          putOnTreatment(patient)
        }
      })
    } else {
      if(identifier && patient && evt) {
        evt.stopPropagation();
        navigate(`/${identifier}`, {state: identifier?.toUpperCase() === 'TAKETEST'? {goTo: 'taketest', user_obj: patient} : {user_obj: patient}})
      } else {
        evt.stopPropagation();
      }
    }
  }

  const putOnTreatment = async (patient) => {
    setIsLoading(true)
    let params = {
      order_id: String(patient.order_id),
      order_status: 'on_treatment'
    }
    console.log("update_order_status params", params);
    try {
      let res = await postApi('update_order_status', params)
      console.log("update_order_status res", res);
      setIsLoading(false)
      if(res?.error) {
        serviceDown()
      } else {
        swal({
          title: i18next.t("Patient has been successfully put on treatment."),
          icon: 'success'
        }).then(() => {
          getPatientReportListForNurse()
        })
      }
    } catch (err) {
      console.log("err", err);
      setIsLoading(false)
      serviceDown()
    }
  }

  const getPrescription = async (patient, prescription_status) => {
    setIsLoading(true) 
    let params = {
      user_id: patient?.user_id,
    }
    console.log("get_user_prescriptions params", params);
    try {
      let res = await postApi('get_user_prescriptions', params)
      console.log("get_user_prescriptions res", res);
      setIsLoading(false)
      if(res?.error) {
        serviceDown()
      } else {
        navigate('/userprescription', {state: 
          {
            prescription: res?.prescriptions[0]?.patient_prescription, 
            user_obj: patient, 
            prescribed_medicine: res?.prescriptions[0]?.prescribed_medicine,
            file_type: res?.prescriptions[0]?.file_type
          }
        })
      }
    } catch (err) {
      console.log("err", err);
      setIsLoading(false)
      serviceDown()
    }
  }

  const searchPatient = async (value, tab) => {
    const query = value.trim();
    if(query === ''){
      // setPatientReportList(tempPatientReportList)
      setGroupedReportList(tempPatientReportList)
      return
    } else {
      let filteredArr = tempPatientReportList[tab].filter((patient) => 
        patient?.first_name?.toUpperCase().includes(query.toUpperCase()) || 
        patient?.last_name?.toUpperCase().includes(query.toUpperCase())
      )
      const filteredTemp = {
        ...tempPatientReportList,
        [tab]: filteredArr
      };
      // console.log("filteredArr", filteredArr, filteredTemp);
      // setPatientReportList(filteredTemp)
      setGroupedReportList(filteredTemp)
    }
  }

  return (
    <>
      {isLoading && <MainLoader />}
      <div className="photo-container main-section-container assessmentReportSection">
        <Grid
          container
          spacing={0}
          className="d-flex justify-content-start align-items-center header"
        >
          {
            localStorage.getItem('user_role')?.toUpperCase() === 'NURSE' &&
            <Grid item xs={1} className="">
              <div className="d-flex justify-content-start align-items-center">
                <span
                  className="backButtonDiv"
                  onClick={() => navigate('/homepage')}
                >
                  <ArrowBackOutlinedIcon className="arrowBackBtn"></ArrowBackOutlinedIcon>
                </span>
              </div>
            </Grid>
          }
          <Grid
            item
            xs={localStorage.getItem('user_role')?.toUpperCase() === 'NURSE' ? 9 : 10}
            className="d-flex justify-content-center align-items-center reportPageHead"
          >
            <Typography variant="h6" className={localStorage.getItem('user_role')?.toUpperCase() === 'NURSE' ? "title ml-0px" : "title ml-50px"}>
              {i18next.t("Patients")}
            </Typography>
          </Grid>
          <Grid item xs={1} onClick={handleRotate} className="cursor-pointer">
            <SyncIcon className={isRotating ? "rotate-once" : ""} />
          </Grid>
          <Grid item xs={1}>
            <Sidebar />
          </Grid>
        </Grid>
        {/* <div className="d-flex justify-content-end align-items-center mt-20px">
          <Button
            variant="contained"
            className="betaUserFeedbackLink"
            onClick={() => proceedToNxt()}
          >
            {i18next.t("Beta Test Feedback")}
          </Button>
        </div> */}
        {
          localStorage.getItem('user_role').toUpperCase() === 'NURSE' ?
          <>
            <Tabs
              value={tabValue}
              onChange={(e, newVal) => setTabValue(newVal)}
              variant="scrollable"
              scrollButtons="auto"
              // allowScrollButtonsMobile
              className={
                Object.keys(groupedReportList)?.length === 1 ? 
                  'onetab' 
                    : 
                Object.keys(groupedReportList)?.length === 2 ? 
                  'twotab' 
                    : 
                Object.keys(groupedReportList)?.length === 3 ? 
                  'threetab' 
                    :
                  'onetab'
              }
            >
              {
                groupedReportList && 
                Object.keys(groupedReportList).length > 0 && 
                Object.keys(groupedReportList).map((key, idx) => {
                  return (
                    <Tab label={i18next.t(key === 'pending' ? "Not on Treatment" : key === 'unordered' ? "Unordered" : "On Treatment")} {...a11yProps(idx)}/>
                  )
                })
              }
            </Tabs>
            {
              groupedReportList && 
              Object.keys(groupedReportList).length > 0 && 
              Object.keys(groupedReportList).map((key, idx) => {
                return (
                  <CustomTabPanel
                    value={tabValue}
                    index={idx}
                  >
                    {
                      !noData &&
                        <Grid container spacing={0} className="d-flex justify-content-center align-items-center searchDiv mt-15px mb-10px">
                          <Grid item xs={12} className="d-flex justify-content-end align-items-center">
                            <TextField
                              type="search"
                              className="searchInput w-100"
                              onChange={(e) => searchPatient(e.target.value, key)}
                              placeholder={i18next.t("Enter name to search")}
                              InputProps={{
                                startAdornment: <SearchIcon className=" mr-5px" />
                              }}
                            />
                          </Grid>
                        </Grid>
                    }
                    
                    {
                      !noData ? 
                        <div className="reportcardscontainer">
                          {
                            groupedReportList[key]?.length > 0 && groupedReportList[key].map((patient) => {
                              return (
                                <Accordion key={patient?.user_id} className="reportPageaccordian nurse">
                                  <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                  
                                  >
                                    <Grid container spacing={0} className="d-flex justify-content-space-around align-items-center pb-16px border-bottom-dashed">
                                      {/* <Grid item xs={1} className="d-flex justify-content-center align-items-center pr-10px">
                                        {console.log("keysssssssss", groupedReportList, key, patient, tabValue)
                                        }
                                        {
                                          key.toUpperCase() === "PENDING" ?
                                            <CheckCircleIcon className="notontreatment"/> 
                                              :
                                            <CheckCircleIcon className="ontreatment"/>
                                        }
                                      </Grid> */}
                                      <Grid item xs={7} className="d-flex justify-content-center align-items-start flex-direction-column">
                                        <p className="patientName text-left mb-0">{patient?.first_name + " " + patient?.last_name}</p>
                                        <div className="d-flex justify-content-center align-items-center mt-5px">
                                          {
                                            patient?.gender?.toUpperCase() === 'MALE' ?
                                              <ManIcon className="fs-18px"/> 
                                                :
                                              <WomanIcon className="fs-18px"/>
                                          }
                                          <p className="patientName mb-0 mr-10px fs-13px">{patient?.gender?.toUpperCase() === 'MALE' ? 'M' : 'F'}</p>
                                          <DateRangeIcon className="fs-18px mr-5px"/>
                                          <p className="patientName mb-0 fs-13px">{patient?.year_of_birth ? patient?.year_of_birth : 'NA'}</p>
                                        </div>
                                      </Grid>
                                      <Grid item xs={5} className="d-flex justify-content-center align-items-center">
                                        {
                                          patient?.reports?.length > 0 ?
                                            <p className='reportSubInfo reportStage mb-0'>{`Stage ${patient?.reports[0]?.norwoodstage ? patient?.reports[0]?.norwoodstage : 'NA'}`}</p> 
                                              :
                                            <div className="hairAnalysisDiv d-flex justify-content-center align-items-center flex-direction-column">
                                              <div className='reportSubInfo reportStage mb-5px d-flex justify-content-space-evenly align-items-center'>
                                                <img className="w-15px mr-5px" src={HairAnalysisIcon}/>
                                                <p className='mb-0'>{i18next.t('Pending')}</p>
                                              </div>
                                              {/* <span>{i18next.t('Pending')}</span> */}
                                            </div>
                                        }
                                      </Grid>
                                    </Grid>
                                    <Grid container spacing={0} className="d-flex justify-content-space-evenly align-items-center mt-15px">
                                      {
                                        localStorage.getItem('user_role')?.toUpperCase() === 'NURSE' ?
                                          <>
                                            <Grid item xs={4} className="d-flex justify-content-center align-items-center flex-direction-column cursor-pointer" 
                                              onClick={(e) => {
                                                handleClicks('taketest', patient, e)
                                              }}
                                            >
                                              <img className="w-25px mb-5px" src={HairAnalysisIcon}/>
                                                {
                                                  patient?.reports?.length > 0 ?
                                                    <CheckCircleIcon className="statusIcon hair complete"/> 
                                                      : 
                                                    <PendingIcon className="statusIcon hair pending"/>
                                                }
                                              <p className="mb-0 icontxt">{i18next.t('Hair')}</p>
                                            </Grid>
                                            <Grid item xs={4} 
                                              className={patient?.reports?.length > 0 ? 
                                                "d-flex justify-content-center align-items-center flex-direction-column cursor-pointer" : 
                                                "d-flex justify-content-center align-items-center flex-direction-column cursor-pointer disabled" 
                                              }
                                              onClick={(e) => {
                                                patient?.reports?.length > 0 ? handleClicks('healthdeclaration', patient, e) : handleClicks('', '', e)
                                              }}
                                            >
                                              <HealthAndSafetyIcon className="fs-25px mb-5px"/>
                                                {
                                                  patient?.medical_history_present?
                                                    <CheckCircleIcon className="statusIcon hair complete"/> 
                                                      :
                                                    <PendingIcon className="statusIcon hair pending"/>
                                                }
                                              <p className="mb-0 icontxt">{i18next.t('Health')}</p>
                                            </Grid>
                                            <Grid item xs={4} 
                                              className={(key.toUpperCase() !== "PENDING" && key.toUpperCase() !== "UNORDERED") ? 
                                                "d-flex justify-content-center align-items-center flex-direction-column cursor-pointer" : 
                                                "d-flex justify-content-center align-items-center flex-direction-column cursor-pointer disabled" 
                                              }
                                              onClick={(e) => {
                                                (key.toUpperCase() === "PENDING" && key.toUpperCase() !== "UNORDERED") ? handleClicks('treatment', patient, e) : handleClicks('', '', e)
                                              }}
                                            >
                                              <img className="w-25px mb-5px" src={(key.toUpperCase() !== "PENDING" && key.toUpperCase() !== "UNORDERED") ? HairTreatment : HairTreatmentDisabled}/>
                                              {/* <HealthAndSafetyIcon className="fs-25px mb-5px"/> */}
                                                {
                                                  (key.toUpperCase() !== "PENDING" && key.toUpperCase() !== "UNORDERED") ?
                                                    <CheckCircleIcon className="statusIcon hair complete"/> 
                                                      :
                                                    <PendingIcon className="statusIcon hair pending"/>
                                                }
                                              <p className="mb-0 icontxt">{i18next.t('Treatment')}</p>
                                            </Grid>
                                          </> 
                                            :
                                          <>
                                            <Grid item xs={6} className="d-flex justify-content-center align-items-center flex-direction-column cursor-pointer" 
                                              onClick={(e) => {
                                                handleClicks('taketestqr', patient, e)
                                              }}
                                            >
                                              <img className="w-25px mb-5px" src={HairAnalysisIcon}/>
                                                {
                                                  patient?.reports?.length > 0 ?
                                                    <CheckCircleIcon className="statusIcon hair complete"/> 
                                                      : 
                                                    <PendingIcon className="statusIcon hair pending"/>
                                                }
                                              <p className="mb-0 icontxt">{i18next.t('Hair')}</p>
                                            </Grid>
                                            <Grid item xs={6} 
                                              className={patient?.medical_history_present ? 
                                                "d-flex justify-content-center align-items-center flex-direction-column cursor-pointer cursor-pointer" : 
                                                "d-flex justify-content-center align-items-center flex-direction-column cursor-pointer disabled" 
                                              }
                                              onClick={(e) => {
                                                patient?.medical_history_present ? handleClicks('prescriptions', patient, e) : handleClicks('', '', e)
                                              }}
                                            >
                                              <div className="d-flex justify-content-center align-items-center">
                                                <NoteAltIcon className="fs-25px mb-5px"/>
                                                {
                                                  patient?.prescription_status?.toUpperCase() === 'VALID' ?
                                                    <CheckCircleIcon className="statusIcon complete"/> 
                                                      :
                                                  patient?.prescription_status?.toUpperCase() === 'EXPIRED' ?
                                                    <ErrorIcon className="statusIcon expired"/>
                                                      : 
                                                    <PendingIcon className="statusIcon pending"/>
                                                }
                                              </div>
                                              <p className="mb-0 icontxt">{i18next.t('Prescription')}</p>
                                            </Grid>                                       
                                          </>
                                      }
                                      {/* <Grid item xs={3}
                                        className={patient?.prescription_status?.toUpperCase() === 'VALID' ? 
                                          "d-flex justify-content-end align-items-end flex-direction-column cursor-pointer" : 
                                          "d-flex justify-content-end align-items-end flex-direction-column cursor-poin ter disabled" 
                                        }
                                        onClick={(e) => {
                                          patient?.prescription_status?.toUpperCase() === 'VALID' ? handleClicks('order', patient, e) : handleClicks('', '', e)
                                        }}
                                      >
                                        <ShoppingCartIcon className="fs-25px mb-5px mr-8px"/>
                                        <p className="mb-0 icontxt">{i18next.t('Order')}</p>
                                      </Grid> */}
                                    </Grid>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                    {
                                      patient?.reports?.length > 0 ? 
                                        patient.reports.map((report) => {
                                          return(
                                            <div 
                                              className="reportCard cursor-pointer"
                                              key={report.analysis_id}
                                              onClick={() => goToReport(report, patient)}
                                            >
                                              <Grid container spacing={2} className="reportCardMain">
                                                <Grid item xs={2} className="iconContainer">
                                                  <img src={imgurl.reportIcon} className="reportIcon"/>
                                                </Grid>
                                                <Grid item xs={7} className="repInfo">
                                                  <p className="mb-0 reportId">{`${i18next.t("Report ID")}: ${report.report_id}`}</p>
                                                  <p className="mb-0 reportDate">{`${i18next.t("Created")}: ${moment(report.analysis_time).format("LL")}`}</p>
                                                </Grid>
                                                {
                                                  report.current_stage === "VALIDATOR_2_COMPLETED" && report.status != "Rejected" ? 
                                                  (
                                                    <Grid item xs={3} className="statusReportDiv completed">
                                                      <CheckCircleIcon />
                                                      <Typography className="completedTxt">
                                                        {i18next.t("Report")}
                                                      </Typography>
                                                    </Grid>
                                                  ) : (report.current_stage === "AI_GENERATED" ||report.current_stage === "VALIDATOR_1_COMPLETED") && report.status != "Rejected" ? 
                                                  (
                                                    <Grid item xs={3} className="statusReportDiv quickreport">
                                                      <OfflineBoltIcon />
                                                      <Typography className="quickreportTxt">
                                                        {}
                                                        {i18next.t("Report")}
                                                      </Typography>
                                                    </Grid>
                                                  ) : (report.current_stage === "AI_GENERATED" || report.current_stage === "VALIDATOR_1_ASSIGNED") && report.status != "Rejected" ? 
                                                  (
                                                    <Grid item xs={3} className="statusReportDiv generating">
                                                      <ThreeDots
                                                        visible={true}
                                                        height="20"
                                                        width="25"
                                                        color="red"
                                                        radius="9"
                                                        ariaLabel="three-dots-loading"
                                                        wrapperStyle={{}}
                                                        wrapperClass=""
                                                      />
                                                      <Typography className="generatingDiv">
                                                        {report.status === "Completed"
                                                          ? i18next.t("Report")
                                                          : "In Progress"}
                                                      </Typography>
                                                    </Grid>
                                                  ) : report.status === "Rejected" ? 
                                                  (
                                                    <Grid item xs={3} className="statusReportDiv rejectDiv">
                                                      <CancelIcon />
                                                      <Typography className="rejectTxt">
                                                        {i18next.t("Invalid")}
                                                      </Typography>
                                                    </Grid>
                                                  ) : (
                                                    ""
                                                  )
                                                }
                                              </Grid>
                                              {
                                                report.status != "Rejected" ? 
                                                  <div className='reportSubCardMain'>
                                                    <p className='reportSubInfo reportStage'>{`Stage ${report.norwoodstage}`}</p>
                                                    {/* <p className={report?.norwoodstage == 1 ? 'reportSubInfo reportStage explore disabled' : 'reportSubInfo reportStage explore'} onClick={(e) => handleExplore(e, report)}>{i18next.t('Place Order')}</p> */}
                                                  </div>
                                                    :
                                                  <div className='reportSubCardMain invalid'>
                                                    <p className='reportSubInfo reportStage'>{`Reason: ${report.reason}`}</p>
                                                  </div>
                                              }
                                            </div>
                                          )
                                        }) 
                                          :
                                        <p className="noreportstxt">
                                          {i18next.t("No reports")}
                                        </p>            
                                    }
                                  </AccordionDetails>
                                </Accordion>
                              )
                            })
                          }
                        </div>
                          : 
                      inProcess ?
                        <div className="nodatadiv">
                          <div className="nodatafoundimg">
                            <img src={inProcessIcon} />
                          </div>
                          <Typography className="">
                            {i18next.t("Just a moment, your report is on the way.")}
                          </Typography>
                        </div> 
                          :
                        <div className="nodatadiv">
                          <div className="nodatafoundimg">
                            <img src={noDataFound} />
                          </div>
                          <Typography className="">
                            {i18next.t("No reports found.")}
                          </Typography>
                        </div>
                    }
                  </CustomTabPanel>
                )
              })
            }
          </> 
            :
          <>
            {
              !noData &&
                <Grid container spacing={0} className="d-flex justify-content-center align-items-center searchDiv mt-5px mb-10px">
                  <Grid item xs={12} className="d-flex justify-content-end align-items-center">
                    <TextField
                      type="search"
                      className="searchInput w-100"
                      onChange={(e) => searchPatient(e.target.value)}
                      placeholder={i18next.t("Enter name to search")}
                      InputProps={{
                        startAdornment: <SearchIcon className=" mr-5px" />
                      }}
                    />
                  </Grid>
                </Grid>
            }

            {
              !noData ? 
                <div className="reportcardscontainer doctor">
                  {
                    patientReportList?.length > 0 && patientReportList.map((patient) => {
                      return (
                        <Accordion key={patient?.user_id} className="reportPageaccordian">
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                          
                          >
                            <Grid container spacing={0} className="d-flex justify-content-space-around align-items-center pb-16px border-bottom-dashed">
                              <Grid item xs={7} className="d-flex justify-content-center align-items-start flex-direction-column">
                                <p className="patientName text-left mb-0">{patient?.first_name + " " + patient?.last_name}</p>
                                <div className="d-flex justify-content-center align-items-center mt-5px">
                                  {
                                    patient?.gender?.toUpperCase() === 'MALE' ?
                                      <ManIcon className="fs-18px"/> 
                                        :
                                      <WomanIcon className="fs-18px"/>
                                  }
                                  <p className="patientName mb-0 mr-10px fs-13px">{patient?.gender?.toUpperCase() === 'MALE' ? 'M' : 'F'}</p>
                                  <DateRangeIcon className="fs-18px mr-5px"/>
                                  <p className="patientName mb-0 fs-13px">{patient?.year_of_birth ? patient?.year_of_birth : 'NA'}</p>
                                </div>
                              </Grid>
                              <Grid item xs={5} className="d-flex justify-content-center align-items-center">
                                {
                                  patient?.reports?.length > 0 ?
                                    <p className='reportSubInfo reportStage mb-0'>{`Stage ${patient?.reports[0]?.norwoodstage ? patient?.reports[0]?.norwoodstage : 'NA'}`}</p> 
                                      :
                                    <div className="hairAnalysisDiv d-flex justify-content-center align-items-center flex-direction-column">
                                      <div className='reportSubInfo reportStage mb-5px d-flex justify-content-space-evenly align-items-center'>
                                        <img className="w-15px mr-5px" src={HairAnalysisIcon}/>
                                        <p className='mb-0'>{i18next.t('Pending')}</p>
                                      </div>
                                      {/* <span>{i18next.t('Pending')}</span> */}
                                    </div>
                                }
                              </Grid>
                            </Grid>
                            <Grid container spacing={0} className="d-flex justify-content-space-evenly align-items-center mt-15px">
                              {
                                localStorage.getItem('user_role')?.toUpperCase() === 'NURSE' ?
                                  <>
                                    <Grid item xs={6} className="d-flex justify-content-center align-items-center flex-direction-column cursor-pointer" 
                                      onClick={(e) => {
                                        handleClicks('taketest', patient, e)
                                      }}
                                    >
                                      <img className="w-25px mb-5px" src={HairAnalysisIcon}/>
                                        {
                                          patient?.reports?.length > 0 ?
                                            <CheckCircleIcon className="statusIcon hair complete"/> 
                                              : 
                                            <PendingIcon className="statusIcon hair pending"/>
                                        }
                                      <p className="mb-0 icontxt">{i18next.t('Hair')}</p>
                                    </Grid>
                                    <Grid item xs={6} 
                                      className={patient?.reports?.length > 0 ? 
                                        "d-flex justify-content-center align-items-center flex-direction-column cursor-pointer" : 
                                        "d-flex justify-content-center align-items-center flex-direction-column cursor-pointer disabled" 
                                      }
                                      onClick={(e) => {
                                        patient?.reports?.length > 0 ? handleClicks('healthdeclaration', patient, e) : handleClicks('', '', e)
                                      }}
                                    >
                                      <HealthAndSafetyIcon className="fs-25px mb-5px"/>
                                        {
                                          patient?.medical_history_present?
                                            <CheckCircleIcon className="statusIcon hair complete"/> 
                                              :
                                            <PendingIcon className="statusIcon hair pending"/>
                                        }
                                      <p className="mb-0 icontxt">{i18next.t('Health')}</p>
                                    </Grid>
                                  </> 
                                    :
                                  <>
                                    <Grid item xs={6} className="d-flex justify-content-center align-items-center flex-direction-column cursor-pointer" 
                                      onClick={(e) => {
                                        handleClicks('taketestqr', patient, e)
                                      }}
                                    >
                                      <img className="w-25px mb-5px" src={HairAnalysisIcon}/>
                                        {
                                          patient?.reports?.length > 0 ?
                                            <CheckCircleIcon className="statusIcon hair complete"/> 
                                              : 
                                            <PendingIcon className="statusIcon hair pending"/>
                                        }
                                      <p className="mb-0 icontxt">{i18next.t('Hair')}</p>
                                    </Grid>
                                    <Grid item xs={6} 
                                      className={patient?.medical_history_present ? 
                                        "d-flex justify-content-center align-items-center flex-direction-column cursor-pointer cursor-pointer" : 
                                        "d-flex justify-content-center align-items-center flex-direction-column cursor-pointer disabled" 
                                      }
                                      onClick={(e) => {
                                        patient?.medical_history_present ? handleClicks('prescriptions', patient, e) : handleClicks('', '', e)
                                      }}
                                    >
                                      <div className="d-flex justify-content-center align-items-center">
                                        <NoteAltIcon className="fs-25px mb-5px"/>
                                        {
                                          patient?.prescription_status?.toUpperCase() === 'VALID' ?
                                            <CheckCircleIcon className="statusIcon complete"/> 
                                              :
                                          patient?.prescription_status?.toUpperCase() === 'EXPIRED' ?
                                            <ErrorIcon className="statusIcon expired"/>
                                              : 
                                            <PendingIcon className="statusIcon pending"/>
                                        }
                                      </div>
                                      <p className="mb-0 icontxt">{i18next.t('Prescription')}</p>
                                    </Grid>                                       
                                  </>
                              }
                              {/* <Grid item xs={3}
                                className={patient?.prescription_status?.toUpperCase() === 'VALID' ? 
                                  "d-flex justify-content-end align-items-end flex-direction-column cursor-pointer" : 
                                  "d-flex justify-content-end align-items-end flex-direction-column cursor-poin ter disabled" 
                                }
                                onClick={(e) => {
                                  patient?.prescription_status?.toUpperCase() === 'VALID' ? handleClicks('order', patient, e) : handleClicks('', '', e)
                                }}
                              >
                                <ShoppingCartIcon className="fs-25px mb-5px mr-8px"/>
                                <p className="mb-0 icontxt">{i18next.t('Order')}</p>
                              </Grid> */}
                            </Grid>
                          </AccordionSummary>
                          <AccordionDetails>
                            {
                              patient?.reports?.length > 0 ? 
                                patient.reports.map((report) => {
                                  return(
                                    <div 
                                      className="reportCard cursor-pointer"
                                      key={report.analysis_id}
                                      onClick={() => goToReport(report, patient)}
                                    >
                                      <Grid container spacing={2} className="reportCardMain">
                                        <Grid item xs={2} className="iconContainer">
                                          <img src={imgurl.reportIcon} className="reportIcon"/>
                                        </Grid>
                                        <Grid item xs={7} className="repInfo">
                                          <p className="mb-0 reportId">{`${i18next.t("Report ID")}: ${report.report_id}`}</p>
                                          <p className="mb-0 reportDate">{`${i18next.t("Created")}: ${moment(report.analysis_time).format("LL")}`}</p>
                                        </Grid>
                                        {
                                          report.current_stage === "VALIDATOR_2_COMPLETED" && report.status != "Rejected" ? 
                                          (
                                            <Grid item xs={3} className="statusReportDiv completed">
                                              <CheckCircleIcon />
                                              <Typography className="completedTxt">
                                                {i18next.t("Report")}
                                              </Typography>
                                            </Grid>
                                          ) : (report.current_stage === "AI_GENERATED" ||report.current_stage === "VALIDATOR_1_COMPLETED") && report.status != "Rejected" ? 
                                          (
                                            <Grid item xs={3} className="statusReportDiv quickreport">
                                              <OfflineBoltIcon />
                                              <Typography className="quickreportTxt">
                                                {}
                                                {i18next.t("Report")}
                                              </Typography>
                                            </Grid>
                                          ) : (report.current_stage === "AI_GENERATED" || report.current_stage === "VALIDATOR_1_ASSIGNED") && report.status != "Rejected" ? 
                                          (
                                            <Grid item xs={3} className="statusReportDiv generating">
                                              <ThreeDots
                                                visible={true}
                                                height="20"
                                                width="25"
                                                color="red"
                                                radius="9"
                                                ariaLabel="three-dots-loading"
                                                wrapperStyle={{}}
                                                wrapperClass=""
                                              />
                                              <Typography className="generatingDiv">
                                                {report.status === "Completed"
                                                  ? i18next.t("Report")
                                                  : "In Progress"}
                                              </Typography>
                                            </Grid>
                                          ) : report.status === "Rejected" ? 
                                          (
                                            <Grid item xs={3} className="statusReportDiv rejectDiv">
                                              <CancelIcon />
                                              <Typography className="rejectTxt">
                                                {i18next.t("Invalid")}
                                              </Typography>
                                            </Grid>
                                          ) : (
                                            ""
                                          )
                                        }
                                      </Grid>
                                      {
                                        report.status != "Rejected" ? 
                                          <div className='reportSubCardMain'>
                                            <p className='reportSubInfo reportStage'>{`Stage ${report.norwoodstage}`}</p>
                                            {/* <p className={report?.norwoodstage == 1 ? 'reportSubInfo reportStage explore disabled' : 'reportSubInfo reportStage explore'} onClick={(e) => handleExplore(e, report)}>{i18next.t('Place Order')}</p> */}
                                          </div>
                                            :
                                          <div className='reportSubCardMain invalid'>
                                            <p className='reportSubInfo reportStage'>{`Reason: ${report.reason}`}</p>
                                          </div>
                                      }
                                    </div>
                                  )
                                }) 
                                  :
                                <p className="noreportstxt">
                                  {i18next.t("No reports")}
                                </p>            
                            }
                          </AccordionDetails>
                        </Accordion>
                      )
                    })
                  }
                </div>
                  : 
              inProcess ?
                <div className="nodatadiv">
                  <div className="nodatafoundimg">
                    <img src={inProcessIcon} />
                  </div>
                  <Typography className="">
                    {i18next.t("Just a moment, your report is on the way.")}
                  </Typography>
                </div> 
                  :
                <div className="nodatadiv">
                  <div className="nodatafoundimg">
                    <img src={noDataFound} />
                  </div>
                  <Typography className="">
                    {i18next.t("No reports found.")}
                  </Typography>
                </div>
            }
          </>
        }
      </div>
      <AlertComp open={alertopen} msg={alertmsg} page={"report"} />
      <Dialog
        open={showQr}
        onClose={() => setShowQr(false)}
        maxWidth="sm"
        className="commonDialogBox"
      >
        <DialogContent className="qrdialogcontent d-flex justify-content-center align-items-center flex-direction-column">
          <div className="d-flex justify-content-end align-items-end w-100 cursor-pointer" onClick={() => setShowQr(false)}>
            <CloseIcon />
          </div>
          <h3 className="mb-20px">{i18next.t('Open on mobile')}</h3>
          <img className='w-50 mb-10px' src={imgurl.clinicalopexiaqr}/>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default PatientReports;
